import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTag"><Path d="M8.5 7C8.5 7.82843 7.82843 8.5 7 8.5C6.17157 8.5 5.5 7.82843 5.5 7C5.5 6.17157 6.17157 5.5 7 5.5C7.82843 5.5 8.5 6.17157 8.5 7Z" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 12V2.5H12L21.5 12L12 21.5L2.5 12Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTag;
